import type { LolRegionSymbol } from "@/game-lol/constants/constants.mjs";
import { REGION_MAP } from "@/game-lol/constants/constants.mjs";

/**
 * Cast strings to symbols, used for data model transformation.
 */
export default function SymbolRegion(
  value: keyof typeof REGION_MAP | LolRegionSymbol,
): LolRegionSymbol {
  if (typeof value === "symbol") return value;
  return REGION_MAP[`${value}`.toLowerCase() as typeof value]; // as: all keys are lowercase :)
}
